import React from 'react'

import { Layout } from '../components'
import { SearchContainer } from '../containers'

const PageSearch = () => {
  return (
    <Layout>
      <SearchContainer></SearchContainer>
    </Layout>
  )
}

export default PageSearch
